import React from "react";

export function Caption({
  children,
  classes,
}: {
  children: React.ReactNode;
  classes?: string;
}) {
  return (
    <>
      <div
        className={`caption relative mt-5 font-normal text-[14px] text-pn-grey-base w-full ${classes}`}
      >
        {children}
      </div>
    </>
  );
}
